// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;I have said to the Lord, &#145;You are my God;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;listen, O Lord, to the voice of my supplication.<br> </p> </div></div>";
// Exports
module.exports = code;